import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { LicenseManager } from 'ag-grid-enterprise';


if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey('Tigersoft_Tigersoft__single_1_Devs__29_November_2020_[v2]_MTYwNjYwODAwMDAwMA==8afdf5c555f3436582ea27f9690fba62');
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
